export const CircularProgress = ({ paid, totalCount }) => {
  const progress = totalCount > 0 ? (paid / totalCount) * 100 : 0;
  const dashArray = 100;
  const dashOffset = dashArray - progress;

  return (
    <div className="relative w-[38px] h-[38px] md:w-[54px] md:h-[54px] border rounded-full p-[2px] md:p-1 border-black">
      <svg className="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
        <path
          stroke="currentColor"
          className="text-gray-300"
          strokeWidth="3.8"
          fill="none"
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />

        <path
          stroke="currentColor"
          className="text-[#3DB54A]"
          strokeWidth="3.8"
          strokeDasharray={dashArray}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          fill="none"
          d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        />
      </svg>

      <div
        className={`absolute inset-[4px] md:inset-[6px] flex items-center justify-center rounded-full text-black text-xs md:text-sm font-normal transition-colors duration-300 ${
          progress === 100 ? 'bg-[#3DB54A] text-white' : 'bg-transparent'
        }`}
      >
        {totalCount > 0 ? `${paid}/${totalCount}` : '0/0'}
      </div>
    </div>
  );
};
